import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { hideNotification } from '../../actions';
import { areThereNotifications } from '../../functions';
import NotificationsTransition from '../NotificationsTransition';
import Notification from './Notification';
import { MESSAGE_NOT_DELIVERED_NOTIFICATION_ID } from "../../constants";
const useStyles = makeStyles()(() => {
    return {
        container: {
            position: 'absolute',
            bottom: 0,
            width: '100%',
        },
        backgroundContainer: {
            minHeight: '276px',
            opacity: '0.9',
            background: 'linear-gradient(180deg, rgba(23, 23, 23, 0) 0%, rgba(23, 23, 23, 0.5) 21.22%, rgba(23, 23, 23, 0.8) 41.72%, rgba(23, 23, 23, 0.9) 59.5%, #171717 98.72%)',
        },
        notificationsContainer: {
            position: 'absolute',
            top: '0px',
            right: '0px',
            minWidth: '100%',
            maxWidth: '100%',
            zIndex: 600,
            maxHeight: '172px',
            height: '100%',
            justifyContent: 'end',
            alignItems: 'start',
            display: 'flex',
            flexDirection: 'column',
        },
        notificationsScrollContainer: {
            width: '100%',
            overflow: 'scroll',
        },
        notificationsContainerPortal: {
            width: '100%',
            maxWidth: '100%',
        }
    };
});
const NotificationsContainerMobile = ({ _iAmSipGateway, _notifications, dispatch, portal }) => {
    const { classes, cx } = useStyles();
    const _onDismissed = useCallback((uid) => {
        dispatch(hideNotification(uid));
    }, []);
    if (_iAmSipGateway || _notifications.length < 1) {
        return null;
    }
    return (React.createElement("div", { className: classes.container },
        React.createElement("div", { className: classes.backgroundContainer }),
        React.createElement("div", { className: cx(classes.notificationsContainer, {
                [classes.notificationsContainerPortal]: portal
            }), id: 'notifications-container' },
            React.createElement("div", { className: classes.notificationsScrollContainer },
                React.createElement(NotificationsTransition, null, _notifications.map(({ props, uid }, index) => {
                    // для последних 5 показываем обычное уведомление
                    if (index < 5) {
                        return (React.createElement(Notification, { ...props, key: uid, onDismissed: _onDismissed, uid: uid }));
                    }
                    // для всех остальных сразу вызываем _onDismissed и тоже «рисуем»,
                    // но они тут же пропадут
                    _onDismissed(uid);
                    return (React.createElement(Notification, { ...props, key: uid, onDismissed: _onDismissed, uid: uid }));
                }) || null)))));
};
/**
 * Maps (parts of) the Redux state to the associated props for this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const { notifications } = state['features/notifications'];
    const { iAmSipGateway } = state['features/base/config'];
    const { isOpen: isChatOpen } = state['features/chat'];
    const _visible = areThereNotifications(state);
    return {
        _iAmSipGateway: Boolean(iAmSipGateway),
        _isChatOpen: isChatOpen,
        _notifications: _visible ? notifications
            .filter(n => n.uid !== MESSAGE_NOT_DELIVERED_NOTIFICATION_ID)
            .reverse()
            : []
    };
}
export default connect(_mapStateToProps)(NotificationsContainerMobile);
